// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1K5d-","left":"styles_left__3Q7iB"};